import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Header from './Header/Header';
import Footer from './Footer';
import clsx from 'clsx';

const styles = (theme) => {
  return {
    content: {
      position: 'relative',
      maxWidth: 1280,
      margin: '0 auto',
      zIndex: 99,
      marginBottom: theme.spacing(6),
    },
    offset: {
      marginTop: -100,
      // marginTop: -30,
    },
    contentFit: {
      minHeight: 240,
      height: 'calc(100% - 400px - 40px)',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    drawerPaper: {
      top: 40,
      zIndex: 998,
      borderRadius: '0 0 5px 5px',
      padding: '5px 3px',
    },
    drawerModal: {
      zIndex: 997,
    },
  };
};
class Template extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = { panelOpened: false };
  //   this._panelToggle = this._panelToggle.bind(this);
  // }
  // componentDidMount() {
  //   this.props.onMount();
  // }
  // _panelToggle() {
  //   this.setState({ panelOpened: !this.state.panelOpened });
  // }
  render() {
    const { classes, title, children, fit, offset } = this.props;

    return (
      <React.Fragment>
        <Header title={title} />
        <div
          className={clsx(classes.content, { [classes.contentFit]: fit, [classes.offset]: offset !== false })}
        >
          {children}
        </div>
        <Footer style={{ zIndex: 189, marginTop: -10 }} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Template);



// WEBPACK FOOTER //
// ./src/components/Template.jsx